import { tsValidateArray, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { DBDef_Tag, knowledgeManagerDBGroup } from '@app/hcs-shared';
import { Validator_SmartDocParameter, smartDocExternalParamType, smartDocParamType_Dynamic, smartDocParamType_External, smartDocParamType_Static, smartDocStaticParamTypes } from '../../_enum/index.js';
const allowedParamTypes = [smartDocParamType_Static, smartDocParamType_Dynamic, smartDocParamType_External];
const allowedSubTypes = {
    [smartDocParamType_Static]: [...smartDocStaticParamTypes],
    [smartDocParamType_External]: [...smartDocExternalParamType],
};
const Validator_ModifiableProps = {
    label: tsValidateString(),
    title: tsValidateString(),
    sections: tsValidateArray(tsValidateString()),
    params: tsValidateArray(Validator_SmartDocParameter(allowedParamTypes, allowedSubTypes)),
};
const Validator_GeneratedProps = {
    _tagIds: tsValidateArray(tsValidateUniqueId),
    _variableIds: tsValidateArray(tsValidateUniqueId),
    _templateIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_SmartDoc = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'smart-doc',
    entityName: 'smart-doc',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'smart-doc'
    },
    backend: {
        name: 'smart-doc'
    },
    dependencies: {
        _tagIds: {
            dbKey: DBDef_Tag.dbKey,
            fieldType: 'string[]',
        },
        '_variableIds': {
            dbKey: 'variables',
            fieldType: 'string[]'
        },
        _templateIds: {
            dbKey: 'smart-doc',
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map